<fuse-widget class="widget p-0 h-100-p" fxLayout="column">

    <!-- Front -->
    <div class="fuse-widget-front mat-white-bg mat-elevation-z2 h-100-p" fxLayout="column" fxLayoutAlign="stretch stretch">

        <div class="px-16 py-8 border-bottom widget-header title-bar mat-accent-bg" fxLayout="row"
                    fxLayoutAlign="space-between center">
            <div class="mat-accent-bg" fxLayout="row" fxLayoutAlign="start center">
                <div class="h3 title pr-4">{{title}}</div>
                <div *ngIf="data?.length>0" fxLayout="row" fxLayoutAlign="start center">
                    <div class="h3 secondary">({{data?.length}})</div>
                </div>
            </div>
        </div>

        <div class="w-100-p px-8" style="flex: 1 1 auto;box-sizing: border-box;height: 100px;">
            <data-grid style="max-height: 100%;"
                #list
                [rows]="data"
                [columns]="columns"
                [allowCustomisation]="false"
                [keyProperty]="'id'"
                [showButtons]="false"
                [showPager]="false"
                [showRowCount]="false"
                [showSearch]="false"
                (onEdit)="edit($event)"
                (onRowUpdated)="rowUpdated($event)"
                (onPurge)="purge()">
            </data-grid>
        </div>
    </div>


    <!-- / Front -->

</fuse-widget>